import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import CompassOutlinedSvg from "@ant-design/icons-svg/es/asn/CompassOutlined";
import AntdIcon from "../components/AntdIcon";
var CompassOutlined = function CompassOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CompassOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  CompassOutlined.displayName = 'CompassOutlined';
}
export default /*#__PURE__*/React.forwardRef(CompassOutlined);